module.exports = __webpack_public_path__ + "img/face3.c47e6414.png";